import type { PresentationModule } from '../../presentation/types';
import { carbonProof, carbonVerify } from './content';
import { CarbonProofScene } from './scenes/CarbonProofScene';
import { CarbonVerifyScene } from './scenes/CarbonVerifyScene';

export const carbonmoveModule: PresentationModule = {
  id: 'carbonmove',
  label: 'CarbonMove',
  priority: 'standard',
  scenes: [
    { ...carbonProof, module: 'carbonmove', create: (resolved) => new CarbonProofScene(resolved) },
    { ...carbonVerify, module: 'carbonmove', create: (resolved) => new CarbonVerifyScene(resolved) },
  ],
};
